<template>
  <div class="pc-list" ref="list">
    <OrganizationSearch @search="search" />
    <div class="pc-head">
      <div class="pc-head-handle">
        <div class="pc-head-btn">
          <button @click="deleteOrganizationInit">删除</button>
          <span></span>
          <button @click="addOrganization">添加</button>
          <!-- <span></span>
          <button @click="exportOrganization">导出数据</button> -->
        </div>
        <p>{{ "共" + pagination_options.total + "条" }}</p>
      </div>
    </div>

    <el-table
      class="pc-list-table"
      @sort-change="changeSort"
      :data="organizationList"
    >
      <el-table-column width="100" class="singleCheckStyle" fixed="left">
        <template slot="header" slot-scope="header">
          <el-checkbox v-model="isSelectAll" @change="selectAll">{{
            "已选" + checked.length + "个"
          }}</el-checkbox>
        </template>
        <template slot-scope="scope" fixed="left">
          <el-checkbox
            v-model="organizationList[scope.$index].isSelect"
            @change="
              singleCheck(
                scope.$index,
                scope.row.isSelect,
                scope.row.id,
                scope.row
              )
            "
          ></el-checkbox>
        </template>
      </el-table-column>
            <el-table-column
        fixed="left"
        prop="id"
        label="编号"
        sortable="custom"
        width="100"
      ></el-table-column>
      <el-table-column prop="image" label="Logo" width="130" fixed="left">
        <template slot-scope="scope">
          <div class="eltable-img">
            <img
              v-if="scope.row.logo"
              :src="scope.row.logo"
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column
        fixed="left"
        prop="chinese_name"
        label="名称"
        sortable="custom"
        width="120"
      >
        <template slot-scope="scope">
          <div>
            {{
              scope.row.chinese_name
                ? scope.row.chinese_name
                : scope.row.english_name
            }}
          </div>
        </template>
      </el-table-column>
            <el-table-column prop="address" label="地址" width="150" fixed="left">
        <template slot-scope="scope">
          <div >
            {{scope.row.address}}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="website" label="网址" width="220">
        <template slot-scope="scope">
          <div v-if="scope.row.website">
            {{ scope.row.website }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="状态" prop="status" sortable="custom" width="160">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.status"
            active-color="#91CC75"
            inactive-color="#C7C7C7"
            @change="changeState(scope.row)"
            :active-value="1"
            :inactive-value="0"
          >
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column
        label="更新时间"
        prop="update_time"
        sortable="custom"
        width="120"
      >
        <template slot-scope="scope">
          <div>{{ $dtime(scope.row.update_time).format("YYYY-MM-DD") }}</div>
        </template>
      </el-table-column>
      <el-table-column width="180">
        <template slot-scope="scope">
          <button class="btnViewDetail" @click="viewDetail(scope.row)">
            修改
          </button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      class="organizationDialog"
      :title="OrganizationDetail.chinese_name"
      :visible.sync="isUpdateShow"
      width="30%"
    >
      <el-form label-width="80px">
        <el-form-item label="Logo">
          <UploadImage
            :img="OrganizationDetail.logo"
            :width="200"
            :height="160"
            @getUploadImage="getUploadImage"
          ></UploadImage>
        </el-form-item>

        <el-form-item label="中文名">
          <el-input
            v-model="OrganizationDetail.chinese_name"
            placeholder="请输入中文名"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="英文名">
          <el-input
            v-model="OrganizationDetail.english_name"
            placeholder="请输入英文名"
          ></el-input>
        </el-form-item>
                        <el-form-item label="地址">
          <el-input v-model="OrganizationDetail.address" placeholder="请输入地址"></el-input>
        </el-form-item>
                <el-form-item label="网址">
          <el-input v-model="OrganizationDetail.website" placeholder="请输入网址"></el-input>
        </el-form-item>
        <el-form-item label="中文简介">
          <el-input
            type="textarea"
            :rows="2"
            v-model="OrganizationDetail.chinese_introduce"
          ></el-input>
        </el-form-item>
        <el-form-item label="英文简介">
          <el-input
            type="textarea"
            :rows="2"
            v-model="OrganizationDetail.english_introduce"
          ></el-input>
        </el-form-item>
        <el-switch
          v-model="OrganizationDetail.status"
          active-color="#91CC75"
          inactive-color="#C7C7C7"
          :active-value="1"
          :inactive-value="0"
          style="margin-left: 40px"
        >
        </el-switch>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          class="dialog-footer-button-one"
          @click="isUpdateShow = false"
          >取 消</el-button
        >
        <el-button
          class="dialog-footer-button-second"
          type="primary"
          @click="submitBanner(OrganizationDetail)"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <DeleteHint
      :dialogVisible="deleteDialogVisible"
      @cancel="closeDelete"
      @delete="isDelete"
    />
    <Pagination
      v-if="organizationList.length > 0"
      :pagination="pagination_options"
      @goPage="goPage"
    />
    <!-- @handleCurrentChange="goPage"
      @goLastPage="goPage"
      @goFirstPage="goPage" -->
  </div>
</template>

<script>
import Pagination from "@/components/componentSet/Pagination";
import OrganizationSearch from "./OrganizationSearch";
import DeleteHint from "@/components/template/DeleteHint";
import UploadImage from "../../../componentSet/uploadImage.vue";
import {
  getOrganizationList_Api,
  updateOrganizationDetail_Api,
  deleteOrganizationList_Api,
  getOrganizationDetail_Api,
  setOrganizationDetail_Api,
  //   outputOrganization_Api
} from "@/apis/exhibition.api";
export default {
  components: {
    UploadImage,
    OrganizationSearch,
    Pagination,
    DeleteHint,
  },
  data() {
    return {
      loading: false,
      isUpdateShow: false,
      deleteDialogVisible: false,
      isActive: null,
      searchRules: {
        page: 1,
        page_size: 10,
        order: "-id",
      },
      pagination_options: {
        page: 1,
        total: 0,
        take: 10,
      },
      OrganizationDetail: {
        logo: "",
        organization_id: null,
        status:0,
      },
      isSelectAll: false,
      organizationList: [],
      checked: [],
    };
  },
  mounted() {
    this.getOrganizationListByRules(this.searchRules);
  },
  methods: {
    // 获取
    getOrganizationListByRules(data) {
      this.loading = true;
      getOrganizationList_Api(data)
        .then((res) => {
          console.log(res.data);
          this.$set(this.pagination_options, "total", res.count);
          res.data.forEach((el) => {
            el.isSelect = false;
          });
          this.organizationList = res.data;
          this.loading = false;
          this.$global.success(this, "获取成功", null);
        })
        .catch(() => {
          this.loading = false;
          this.$global.error(this, "获取失败！", null);
        });
    },
    // 全选按钮
    selectAll() {
      if (this.isSelectAll) {
        this.checked = [];
        this.checked = [];
        this.organizationList.forEach((item, i, arr) => {
          this.$set(item, "isSelect", true);
          this.checked.push(item.id);
        });
      } else {
        this.organizationList.forEach((item, i, arr) => {
          item.isSelect = false;
          this.checked = [];
        });
      }
    },
    // 单选按钮
    singleCheck(index, isSelect, rowID, row) {
      if (isSelect == false) {
        this.isSelectAll = false;
        for (let i = 0; this.checked.length > i; i++) {
          if (this.checked[i] == rowID) {
            this.checked.splice(i, 1);
            return;
          }
        }
      } else {
        this.checked.push(rowID);
        if (this.checked.length == 10) {
          this.isSelectAll = true;
        }
      }
    },
    // 排序
    changeSort(val) {
      if (val.order == "ascending") {
        this.searchRules.order = "+" + val.prop;
      }
      if (val.order == "descending") {
        this.searchRules.order = "-" + val.prop;
      }
      if (val.order == null) {
        this.searchRules.order = "-id";
      }
      this.searchRules.page = 1;
      let data = this.dealSearchRules(this.searchRules);
      this.getOrganizationListByRules(data);
      this.pagination_options.page = 1;
    },
    viewDetail(item) {
      this.isUpdateShow = true;
      getOrganizationDetail_Api(item.id).then((res) => {
        this.OrganizationDetail = res.data;
        this.OrganizationDetail.organization_id = this.OrganizationDetail.id;
        // this.OrganizationDetail.magazine_article_id = res.data.id;
        // if (this.OrganizationDetail.author) {
        //   this.OrganizationDetail.author = this.OrganizationDetail.author.split(",");
        // } else {
        //   this.OrganizationDetail.author = [];
        // }
        console.log(res);
      });
    },

    // 修改状态
    changeState(row) {
      updateOrganizationDetail_Api({ organization_id: row.id, status: row.status })
        .then(() => {
          console.log("修改状态成功！");
          this.$global.success(this, "修改状态成功！", null);
        })
        .catch((res) => {
          console.log("修改状态失败！");
        });
    },
    search(formData) {
      console.log(formData);
      this.searchRules = { ...this.searchRules, page: 1, ...formData };
      let data = this.dealSearchRules(this.searchRules);
      console.log(this.searchRules);
      this.getOrganizationListByRules(data);
      this.pagination_options.page = 1;
    },
    dealSearchRules(formData) {
      let data = {};
      if (formData.page) {
        data.page = formData.page;
      }
      if (formData.page_size) {
        data.page_size = formData.page_size;
      }
      if (formData.order) {
        data.order = formData.order;
      }
      if (formData.status) {
        data.status = parseInt(formData.status);
      }
      if (formData.name_keyword) {
        data.name_keyword = formData.name_keyword;
      }
      if (formData.address_keyword) {
        data.address_keyword = formData.address_keyword;
      }
      return data;
    },
    isDelete() {
      let delete_ids = { organization_id_list: this.checked };
      console.log("delete_ids:", delete_ids);
      deleteOrganizationList_Api(delete_ids)
        .then((res) => {
          console.log("批量删除成功！");
          this.checked = [];
          this.deleteDialogVisible = false;
          this.$global.success(this, "删除成功！");
          this.searchRules.page = 1;
          let data = this.dealSearchRules(this.searchRules);
          this.getOrganizationListByRules(data);
          this.pagination_options.page = 1;
        })
        .catch((err) => {
          console.log("批量删除失败！");
        });
    },
    closeDelete() {
      this.deleteDialogVisible = false;
    },
    // 删除设计师
    deleteOrganizationInit() {
      if (this.checked.length > 0) {
        this.deleteDialogVisible = true;
      } else {
        this.$global.error(this, "请先勾选要删除的机构！", null);
      }
    },
    // 添加设计师
    addOrganization() {
      this.isUpdateShow = true;
      for (let key in this.OrganizationDetail) {
        this.OrganizationDetail[key] = null;
      }
        this.OrganizationDetail.status = 0;
    },
    getUploadImage(img_url) {
      this.OrganizationDetail.logo = img_url;
    },
    submitBanner(item) {
      if (this.OrganizationDetail.id == null) {
        setOrganizationDetail_Api(this.OrganizationDetail).then((res) => {
          console.log(res);
          this.getOrganizationListByRules();  
        });
        this.isUpdateShow = !this.isUpdateShow;
        return;
      } else {
        updateOrganizationDetail_Api(this.OrganizationDetail).then((res) => {
          this.getOrganizationListByRules();
          console.log(res);
        });
        this.isUpdateShow = !this.isUpdateShow;
        return;
      }
    },
    // 到出数据
    // exportOrganization() {
    //   if (this.checked.length > 0) {
    //     outputOrganization_Api({organization_id_list: this.checked }).then(
    //       (res) => {
    //         this.$global.downloadFile(res, "organizationList");
    //       }
    //     );
    //   } else {
    //     this.$global.error(this, "请先勾选要导出的项目！", null);
    //   }
    // },

    goPage(pageNo) {
      this.pagination_options.page = pageNo;
      this.searchRules.page = pageNo;
      let data = this.dealSearchRules(this.searchRules);
      this.getOrganizationListByRules(data);
    },
  },
};
</script>



<style lang="scss" scoped>
/deep/ .el-dialog{
    width: 40% !important
}
  /deep/ .el-dialog__footer {
  .dialog-footer-button-one {
    @include manage-button;
    background: $test;
    color: $blueBtna;
  }
  .dialog-footer-button-second {
    @include manage-button;
  }
}
/deep/ .el-upload__tip{
    margin-top: -10px
}
.pc-list {
  @include table-head;
}
</style>


// WEBPACK FOOTER //
// src/components/admin/exhibition/component/OrganizationTable.vue